export const setting = {
    "abay": "Abay Bank",
    "abyssinia": "Abyssinia Bank",
    "bunna":"Bunna Bank",
    tokenKey: "honky-tonky"
}